"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cypressConfig = {
    lineups: {
        createFaceLineup: {
            suspect: {
                bookingNumber: 'LE2TEST00010',
                name: 'JANA RENNER'
            },
            filters: [
                { label: 'Sex', optionsToAdd: [], optionsToRemove: ['FEMALE'] },
                { label: 'Race', optionsToAdd: [], optionsToRemove: ['UNKNOWN'] },
                { label: 'Eye Color', optionsToAdd: [], optionsToRemove: ['PINK'] },
                { label: 'Hair Color', optionsToAdd: [], optionsToRemove: ['BLACK'] },
                { label: 'Hair Length', optionsToAdd: [], optionsToRemove: ['BALD'] },
                { label: 'Hair Style', optionsToAdd: [], optionsToRemove: ['BRAIDS'] },
                { label: 'Facial Hair', optionsToAdd: [], optionsToRemove: ['SHORT'] },
                { label: 'Complexion', optionsToAdd: [], optionsToRemove: ['MEDIUM BROWN'] },
                { label: 'Beard', optionsToAdd: [], optionsToRemove: ['GOATEE'] },
                { label: 'Mustache', optionsToAdd: [], optionsToRemove: ['NONE'] },
                { label: 'Sideburns', optionsToAdd: [], optionsToRemove: ['NO'] },
                { label: 'Glasses', optionsToAdd: [], optionsToRemove: ['NO'] },
                { label: 'Build', optionsToAdd: [], optionsToRemove: ['HEAVY'] }
            ],
            ageFilter: '',
            hasAgeRange: true,
            fillers: ['LE2TEST00005', 'LE2TEST00002', 'LE2TEST00006', 'LE2TEST00008', 'LE2TEST00009']
        },
        selectExistingLineup: {
            existingBookingNumberForNavigation: '23',
            suspect: {
                caseNumber: '3279118693',
                lineupNumber: '43',
                subjectName: 'JANA RENNER',
                type: 'face',
                bookingNumber: 'LE2TEST00010',
                lineupName: 'laboriosam'
            }
        },
        printLineup: {
            lineupNumber: 49
        },
        duplicateLineup: {
            lineupNumber: 42
        }
    },
    bookings: {
        bookingSearch: {
            bookingNumber: 'LE2TEST00049',
            firstName: 'Severus',
            lastName: 'Dumbledore'
        },
        advancedBookingSearch: [
            {
                name: 'First',
                value: 'HELEN',
                type: 'input',
                range: false,
                operator: '='
            },
            {
                name: 'Last',
                value: 'COLE',
                type: 'input',
                range: false,
                operator: '='
            },
            {
                name: 'Date of Birth',
                value: '1980-02-04',
                type: 'date',
                range: false,
                operator: '='
            },
            {
                name: 'Age',
                value: ['18', '40'],
                type: 'input',
                range: true,
                operator: '='
            },
            {
                name: 'Date of Arrest',
                value: ['2012-01-01', '2022-09-01'],
                type: 'date',
                range: true,
                operator: '='
            },
            {
                name: 'UCN',
                value: 'ANIM IRURE LOREM',
                type: 'input',
                range: false,
                operator: 'contains'
            },
            {
                name: 'Booking Agency',
                value: 'AUBURN PD',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Sex',
                value: 'MALE',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Race',
                value: 'NATIVE AMERICAN',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Eye Color',
                value: 'BLACK',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Hair Color',
                value: 'BLACK',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Facial Hair',
                value: 'SHORT',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Height',
                value: ['400', '600'],
                type: 'input',
                range: true,
                operator: '='
            },
            {
                name: 'Weight',
                value: ['200', '400'],
                type: 'input',
                range: true,
                operator: '='
            },
            {
                name: 'Hair Length',
                value: 'SHORT',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Facial Hair',
                value: 'SHORT',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Beard',
                value: 'BEARD',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Mustache',
                value: 'MUSTACHE',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Sideburns',
                value: 'YES',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Complexion',
                value: 'FAIR',
                type: 'select',
                range: false,
                operator: '='
            },
            {
                name: 'Residence of Person Fingerprinted',
                value: 'IN CULPA',
                type: 'input',
                range: false,
                operator: 'contains'
            },
            {
                name: 'Aliases',
                value: 'QUIS CILLUM FUGIAT',
                type: 'input',
                range: false,
                operator: 'contains'
            }
        ],
        selectExistingBooking: {
            bookingNumber: 'LE2TEST00047',
            filters: [
                { fieldName: 'Sex', operator: '=', value: 'UNKNOWN GENDER', type: 'select' },
                { fieldName: 'Date of Birth', operator: '=', value: '1954-06-14', type: 'input' },
                { fieldName: 'Race', operator: '=', value: 'ASIAN', type: 'select' },
                { fieldName: 'Hair Color', operator: '=', value: 'UNKNOWN OR COMPLETELY BALD', type: 'select' },
                { fieldName: 'Height', operator: '=', rangeStart: '511', rangeEnd: '601', type: 'range' }
            ]
        }
    },
    audit: {
        advancedSearch: [
            {
                type: 'Booking',
                eventAction: 'View',
                filters: [
                    {
                        type: 'bookingNumber',
                        value: 'LE2TEST00047'
                    }
                ],
                selectedDates: ['2022-08-01', '2022-08-31']
            },
            {
                type: 'Booking',
                eventAction: 'Search',
                selectedDates: ['2022-08-01', '2022-08-31']
            },
            {
                type: 'Auth',
                eventAction: 'Login',
                selectedDates: ['2022-08-01', '2022-08-31']
            },
            {
                type: 'Auth',
                eventAction: 'Login Fail'
            },
            {
                type: 'Auth',
                eventAction: 'Logout',
                selectedDates: ['2022-08-01', '2022-08-31']
            },
            {
                type: 'Lineup',
                eventAction: 'Create',
                filters: [{ type: 'caseNumber', value: '8954829819' }],
                selectedDates: ['2022-08-01', '2022-08-31']
            },
            {
                type: 'Lineup',
                eventAction: 'View',
                filters: [
                    {
                        type: 'lineupName',
                        value: 'laboriosam'
                    }
                ],
                selectedDates: ['2022-08-01', '2022-08-31']
            },
            {
                type: 'Lineup',
                eventAction: 'Search'
            }
        ]
    }
};
exports.default = cypressConfig;
//# sourceMappingURL=e2e-cypress-config-kcso.js.map